import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { LogoMark } from "../components/Logo";

const VALUES = [
  {
    n: "01",
    title: "Follow your own path",
    body: "Trends are someone else's map. We make gear for people who navigate by their own signal — in the city, on the trail, everywhere between.",
  },
  {
    n: "02",
    title: "Lead with authenticity",
    body: "No borrowed aesthetics, no hype on lease. Heavyweight fabrics, honest construction, prints that mean something. If we wouldn't wear it daily, we don't ship it.",
  },
  {
    n: "03",
    title: "Create your own path",
    body: "TRAILNONE exists so the uniform never becomes a cage. Cut your own route. We'll make sure you're dressed for it.",
  },
];

export default function About() {
  return (
    <div>
      <PageHeader
        eyebrow="The brand"
        title="About TRAILNONE"
        description="Premium streetwear engineered for the ones who move different."
      />

      <section className="border-b border-border px-5 py-16 sm:px-10 lg:px-16 lg:py-24">
        <Reveal>
          <p className="max-w-3xl font-display text-2xl font-semibold leading-snug tracking-tight sm:text-3xl lg:text-4xl">
            TRAILNONE was born from a simple refusal: the refusal to walk a
            route someone else drew. The name says it —{" "}
            <span className="text-signal">no trail but yours</span>.
          </p>
          <p className="mt-8 max-w-2xl text-sm leading-relaxed text-muted-foreground sm:text-base">
            Every garment starts with fabric weight and ends with intent.
            Oversized cuts that move, washes that age with you, reflective
            details that catch headlights on night miles. Designed in-house,
            produced in limited runs, and managed end-to-end through our
            store — so what you see is always exactly what's available.
          </p>
        </Reveal>
      </section>

      <section className="grid gap-px border-b border-border bg-border lg:grid-cols-3">
        {VALUES.map((v, i) => (
          <div key={v.n} className="bg-background px-5 py-12 sm:px-10 lg:px-12 lg:py-16">
            <Reveal delay={i * 0.1}>
              <p className="font-mono text-xs tracking-[0.3em] text-signal">{v.n}</p>
              <h3 className="mt-4 font-display text-xl font-bold uppercase tracking-tight sm:text-2xl">
                {v.title}
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground">{v.body}</p>
            </Reveal>
          </div>
        ))}
      </section>

      <section className="px-5 py-16 text-center sm:px-10 lg:px-16 lg:py-24">
        <Reveal>
          <LogoMark className="mx-auto h-10 w-10" />
          <h2 className="mt-6 font-display text-3xl font-bold uppercase tracking-tighter sm:text-4xl">
            The trail is yours.
          </h2>
          <Link
            to="/shop"
            data-testid="about-shop-link"
            className="group mt-8 inline-flex items-center gap-2 bg-signal px-8 py-4 font-mono text-xs font-bold uppercase tracking-[0.25em] text-white transition-colors hover:bg-signal/90"
          >
            Shop the latest
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
